import {
  bgColors,
  getTextColorFromBackgroundColor,
} from '@teetsh/app/src/components/colors';
import React from 'react';
import tw from 'twin.macro';
import { Color } from '@teetsh/app/src/types/colors';
import { TagColorWithIntensity } from '@teetsh/app/src/styles/userConstants';

interface Props {
  children: React.ReactNode;
  className?: string;
  color?: Color | TagColorWithIntensity;
  truncate?: boolean;
  disableRing?: boolean;
}

export function Surligner(props: Props) {
  const { children, className, truncate = true, disableRing } = props;
  const needsRing =
    !disableRing &&
    (props?.color === 'white' || props?.color === 'gris-supershy');
  return (
    <div
      css={[
        tw`relative inline-flex py-0.5 px-2.5`, // Changé en inline-flex
        tw`max-w-full`, // Ajout d'une largeur maximum
      ]}
      className={className}
    >
      <span
        css={[
          tw`absolute inset-0 rounded-lg skew-x-12`,
          needsRing && tw`ring-1 ring-inset ring-neutral-quiet`,
          bgColors(props.color || 'yellow-200'),
        ]}
      />
      <span
        css={[
          tw`relative min-w-0 flex-1`, // Ajout de min-w-0 et flex-1
          truncate && tw`truncate`,
          getTextColorFromBackgroundColor(props.color || 'white', true),
        ]}
      >
        {children}
      </span>
    </div>
  );
}
